export const SET_FETCHING_HOLDER_SETTINGS = 'SET_FETCHING_HOLDER_SETTINGS';
export const SET_HOLDER_SETTINGS_ERROR = 'SET_HOLDER_SETTINGS_ERROR';

export const SET_HOLDER_SEND_SETTINGS_ERROR = 'SET_HOLDER_SEND_SETTINGS_ERROR';
export const SET_FETCHING_HOLDER_INTEGRATIONS = 'SET_FETCHING_HOLDER_INTEGRATIONS';
export const SET_HOLDER_INTEGRATIONS_ERROR = 'SET_HOLDER_INTEGRATIONS_ERROR';
